import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import theme from 'shared/styles/theme';

const ConfirmAddressSuccess = () => {
  const { t: translatedText } = useTranslation('personalInfoStrings');
  const dismissToTab = useDismissToRootTab();
  const goHome = () => {
    dismissToTab(Tabs.HOME);
  };
  const { fromConfirmAddress } = useLocalSearchParams<{
    fromConfirmAddress: string;
  }>();

  useViewDidFocusScreenAnalyticsEvent({
    key: fromConfirmAddress ? 'home-address-updated-success' : '',
  });

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
          headerShown: false,
          gestureEnabled: false,
        }}
      />
      <SuccessScreen
        visual="CARD_B"
        titleText={translatedText('addressTranslations.successScreen.title')}
        eyebrowText={translatedText(
          'addressTranslations.successScreen.eyebrowText',
        )}
        content={
          <View style={styles.body}>
            <BodyBaseText ellipsizeMode="tail">
              {translatedText('addressTranslations.successScreen.body')}
            </BodyBaseText>
          </View>
        }
        primaryButton={{
          label: translatedText('addressTranslations.successScreen.button'),
          onPress: () => {
            goHome();
          },
          isLoading: false,
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    alignItems: 'center',
    flexShrink: 1,
    paddingHorizontal: theme.spacing.m,
  },
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },
});

export default ConfirmAddressSuccess;
